"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuggestions = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const api_client_1 = require("src/redux/store/api-client");
const getText = (item) => {
    var _a;
    return ((_a = item === null || item === void 0 ? void 0 : item.subtitle) === null || _a === void 0 ? void 0 : _a.text) ? `${item === null || item === void 0 ? void 0 : item.subtitle.text}, ${item.title.text}` : item.title.text;
};
// eslint-disable-next-line import/prefer-default-export
function useSuggestions(accuracy = 'locality', lang = 'ru', suggestCount = 5) {
    const [suggestItems, setSuggestItems] = (0, react_1.useState)([]);
    const apiClient = (0, react_redux_1.useSelector)((state) => (0, api_client_1.getClient)(state.location));
    const fetchSuggestions = (0, react_1.useCallback)(
    // eslint-disable-next-line max-statements
    (part) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!part.trim()) {
            setSuggestItems([]);
            // eslint-disable-next-line padding-line-between-statements
            return;
        }
        try {
            const res = yield apiClient.getGeoSuggestions({
                lang,
                accuracy,
                suggestCount,
                part
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const items = (((_a = res.data) === null || _a === void 0 ? void 0 : _a.results) || []).map((item) => ({
                label: getText(item),
                id: item.geoId
            }));
            setSuggestItems(items);
        }
        catch (e) {
            console.error('Failed to fetch suggestions', e);
            setSuggestItems([]);
        }
    }), [accuracy, lang]);
    const clearSuggestions = () => setSuggestItems([]);
    return { suggestItems, fetchSuggestions, clearSuggestions };
}
exports.useSuggestions = useSuggestions;
